export default `
  font-family: Open Sans;
  border-radius: 4px;
  font-size: 14px;
  padding: 10px 16px;
`



// WEBPACK FOOTER //
// ./src/components/elements/input/style.js